import './App.css';
import WbIndex from "./Components/Wb/Index";
import Loading from "./Components/Loading";
import React, {useContext, useEffect, useState} from "react";

import DataContext from "./context";
function App() {

    const ctx = useContext(DataContext);

    if(ctx.trs.length === 0) {
        return  <Loading/>
    }

    return (
        <div className="App">
            <React.Suspense fallback={<Loading/>}>
                <WbIndex ctx={ctx} btc={ctx.btc} profile={ctx.profile} auth={ctx.auth}  setAuth={ctx.setAuth} ajax={ctx.ajax} addCommos={ctx.addCommos} removeCommos={ctx.removeCommos} logo={ctx.logo} trs={ctx.trs}/>
            </React.Suspense>
        </div>
    );
}

export default App;
